import ViewMojeKonto from "../../components/views/konto/ViewMojeKonto.jsx";
import ViewMojeUprawnienia from "../../components/views/konto/ViewMojeUprawnienia.jsx";

export const otherRoutes = [
    {
        path: '/moje-konto',
        exact: true,
        roles: ['pass'],
        forbidden: true,
        view: <ViewMojeKonto/>,
        mode: 'pass'
    },
    {
        path: '/moje-uprawnienia',
        exact: true,
        roles: ['pass'],
        forbidden: true,
        view: <ViewMojeUprawnienia/>,
        mode: 'pass'
    },
    {
        path: '/uzytkownik/moje-uprawnienia',
        exact: true,
        roles: ['pass'],
        forbidden: true,
        view: <ViewMojeUprawnienia/>,
        mode: 'pass'
    },
]

